import { connect } from 'react-redux'

import type { GlobalState } from '../types'
import { CategorySelect } from './CategorySelect'
import { ClaimHandlerSelect } from './ClaimHandlerSelect'
import { Preview } from './Preview'
import { SpaceAvailable } from './SpaceAvailable'
import { getFileCount, getFileSize } from './upload-selectors'
import { UploadArea } from './UploadArea'
import { UploaderInfo } from './UploaderInfo'
import { UploadSubmit } from './UploadSubmit'

type UploadFormProps = {
  fileCount: number
  filesSize: number
  requesting: boolean
}

const UploadFormComponent = ({ fileCount, filesSize, requesting }: UploadFormProps) => (
  <div>
    <UploaderInfo />
    <ClaimHandlerSelect />
    <CategorySelect />
    <UploadArea />
    <Preview />
    <SpaceAvailable disableField={requesting} space={filesSize} />
    { fileCount > 0 && <UploadSubmit /> }
  </div>
)

const mapStateToProps = (state: GlobalState) => ({
  fileCount: getFileCount(state),
  filesSize: getFileSize(state)
})

const UploadForm = connect(mapStateToProps)(UploadFormComponent)

export { UploadForm }
